require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-java-time-tested-scalable-and-essential-for-the-novice-and-expert-alike.json") })
        }
      }, "path---blog-java-time-tested-scalable-and-essential-for-the-novice-and-expert-alike");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-java-time-tested-scalable-and-essential-for-the-novice-and-expert-alike!./.cache/json/blog-java-time-tested-scalable-and-essential-for-the-novice-and-expert-alike.json
// module id = 922
// module chunks = 231608221292675